<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-17 18:39:17
-->

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  .fa-line {
    display: block;
    border-right: 1px solid #ccc;
  }

  &Left {
    padding-right: 15px;
    width: auto;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    padding-left: 15px;
    border-left: 1px solid #ccc;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchRoleList"
              v-if="searchShow"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchRoleList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="roleId"
              v-loading="loading"
          >
            <el-table-column
                fixed
                label="序号"
                prop="roleId"
                type="index"
                width="80"
            >
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="150">
            </el-table-column>
            <el-table-column prop="dataPermissionName" label="数据权限" min-width="180">
            </el-table-column>
            <el-table-column prop="code" label="标识" min-width="180">
            </el-table-column>
            <el-table-column prop="seq" label="排序" min-width="80">
            </el-table-column>
            <el-table-column prop="descr" label="说明" min-width="180">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="150">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column v-if="editShow || deleteShow || menuShow" fixed="right" label="操作" min-width="220">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                    v-if="editShow"
                >修改
                </el-button
                >
                <el-button
                    type="success"
                    size="small"
                    plain
                    v-if="menuShow"
                    @click="handleClick('menu', scope.row)"
                >菜单
                </el-button
                >
                <el-button
                    type="primary"
                    plain
                    size="small"
                    v-if="deleteShow"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
            <!-- :page-sizes="[10, 15, 20,25 ]" -->
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        :title="
          clickType == 'addgroup'
          ? '新增角色组信息'
          : clickType == 'addNext'
          ? '新增角色信息'
          : clickType == 'edit'
          ? '编辑角色组'
          : clickType == 'change'
          ? '修改角色信息'
          : ' 菜单分配'
      "
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="660px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <!-- 菜单分配 -->
          <el-form-item v-if="clickType == 'menu'" class="item" label="名称："
          >{{ params.name }}
          </el-form-item>
          <el-form-item
              v-if="clickType == 'menu'"
              class="item"
              label="菜单"
          >
            <div class="dialog-tree">
              <el-tree
                  :data="permissionData"
                  show-checkbox
                  node-key="menuId"
                  ref="tree"
                  :props="defaultProps"
              >
              </el-tree>
            </div>
          </el-form-item>
          <template v-if="clickType != 'menu'">
            <el-row>
              <el-col :span="12">
                <el-form-item
                    label="名称："
                    prop="name"
                >
                  <el-input
                      clearable
                      placeholder="请填写角色名称"
                      v-model="params.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                    label="标识："
                    prop="code"
                >
                  <el-input
                      clearable
                      placeholder="请填写标识"
                      v-model="params.code"
                      :disabled="clickType == 'change'"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                    label="数据范围："
                    prop="dataPermission"

                >
                  <el-select style="width: 210px" v-model="params.dataPermission" clearable placeholder="选择操作">
                    <el-option
                        v-for="item in optionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                    label="排序："
                    prop="seq"
                >
                  <el-input
                      clearable
                      placeholder="请填写排序"
                      v-model="params.seq"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
                label="说明："
                prop="descr"
            >
              <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请填写说明"
                  v-model="params.descr"
                  style="width: 100%;"
              ></el-input>
            </el-form-item>
          </template>

        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";

export default {
  data() {
    return {
      PAGE_SIZE,
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      defaultProps: {
        children: "menus",
        label: "name",
      },
      permissionData: [], //角色--菜单树
      treeList: [],
      treeList_one: [],
      optionList: [
        {
          value: "all",
          label: "全部",
        },
        {
          value: "only_self",
          label: "仅本人",
        },
        {
          value: "only_dept",
          label: "本部门",
        },
        {
          value: "dept",
          label: "本部门及下级部门",
        },
      ],
      search: {},
      // input_search: "",
      // value: "", //select1
      value1: "", //select2
      value2: true,

      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写角色名称", trigger: "blur"}],
        code: [{required: false, message: "请填写标识", trigger: "blur"}],
        descr: [{required: false, message: "请填写说明", trigger: "blur"}],
        seq: [{required: false, message: "请填写排序", trigger: "blur"}],
        dataPermission: [{required: true, message: "请选择数据范围"}],
      }, //表单验证提示

      tableData: [], //二级--角色列表

      trees: {
        tree: true,
      },
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      menuShow: false
    };
  },
  created() {
    this.getRoleListTree();
    this.getRoleList();
    this.getPermissionData(); //获取所有菜单权限项目
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.value1 = ''
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:role:menu') {
            this.menuShow = true
          }
          if (item.code == 'system:role:query') {
            this.searchShow = true
          }
          if (item.code == 'system:role:add') {
            this.addShow = true
          }
          if (item.code == "system:role:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:role:edit") {
            this.editShow = true
          }
          if (item.code == "system:role:status") {
            this.statusShow = false
          }
        })
      }
    },
    // async getBtnTree() {
    //   //角色列表
    //   const { data: res } = await this.$get(`/btns?tree=true`);
    //   if (res.result != 200) return;
    //   console.log(res)
    // },
    SearchRoleList() {
      this.page.pageNo = 1
      this.getRoleList()
    },
    /**
     *  get role List  //and table  //left menu  //search
     */
    async getRoleListTree() {
      //角色组--树
      const {data: resData} = await this.$get(
          `/role/list?paging=false&tree=${this.trees.tree}&nodeLevel=1`
      );
      if (resData.data && resData.data.length) this.treeList = resData.data;
    },
    async getRoleList() {
      // this.tableData = [];
      this.loading = true;
      //角色列表
      const {data: res} = await this.$get(
          `/role/list?tree=${!this.trees.tree}`,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
    },
    async getPermissionData() {
      const {data: resData} = await this.$get("/menu/list?tree=true&paging=false");
      if (resData.result != 200) return;
      this.permissionData = resData.data;
    },

    //switch状态改变 --接口 修改角色状态
    handleSwitch(index) {
      this.$put(`/role/info/status/${this.tableData[index].roleId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        this.params = {};
      } else if (type == "change") {
        //修改  change
        this.params = {
          roleId: row.roleId,
          name: row.name,
          descr: row.descr,
          parentId: row.parentId,
          seq: row.seq,
          code: row.code,
          dataPermission: row.dataPermission
        };
      } else if (type == "menu") {
        //菜单
        var that = this;
        that.params = {
          roleId: row.roleId,
          name: row.name,
          descr: row.descr,
          parentId: row.parentId,
        };
        that.$get(`/role/menu/ids?roleId=${row.roleId}`).then((res) => {
          if (res.data.data) {
            (that.params.permission = res.data.data),
                this.$refs.tree.setCheckedKeys(that.params.permission);
          } else {
            this.$refs.tree.setCheckedKeys([]);
          }
        });
      } else {
        //添加
        this.params = {};
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        let passData = {
          name: this.params.name,
          parentId: this.params.parentId,
          roleId: this.params.roleId,
          descr: this.params.descr,
          dataPermission: this.params.dataPermission,
          code: this.params.code,
          seq: this.params.seq
        };
        if (!valid) return;

        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post("/role/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.getRoleList();
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else if (this.clickType == "change") {
            //修改角色
            const {data: resData} = await this.$put(
                "/role/info",
                passData,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.getRoleList();
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("修改成功!");
          } else {
            //菜单分配
            const permission = this.$refs.tree.getCheckedKeys();
            if (!permission) return this.$message.error("请选择菜单！");

            const {data: resData} = await this.$post(
                "/role/menu/ids",
                {
                  menuIds: permission,
                  roleId: passData.roleId,
                },
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.dialogVisible = false;
            // this.queryTableData();//重新获取
            this.$message.success("添加菜单成功!");
          }
        });
      });
    },

    //删除
    async del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/role/info/${row.roleId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getRoleList();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleList();
    },

    // 编辑角色 组时候--change事件 --触发获取其详情
    async selectTrigger(roleId) {
      if (this.clickType == "edit") {
        const {data: res} = await this.$get(`/role/info/${roleId}`);
        this.params = res.data;
      }
    },

  },
};
</script>
